module.exports = __webpack_public_path__ + "img/HerbariumLogo.62f42c8e.png";